<div class="login-container">
  <mat-card class="login-card">
    <div class="header-section">
      <img src="./assets/logo.png" alt="Grenada Logo" class="brand-logo">
      <mat-card-title>Grenada. Automotive Bridge</mat-card-title>
      <mat-card-subtitle>Sign In</mat-card-subtitle>
    </div>

    <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
      <mat-card-content>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>eMail</mat-label>
          <input matInput 
                 [(ngModel)]="userData.email" 
                 name="email"
                 type="email" 
                 required 
                 email
                 placeholder="ex@exemple.gd">
          <mat-icon matSuffix>email</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input matInput 
                 [(ngModel)]="userData.password" 
                 name="password" 
                 type="password" 
                 required>
          <mat-icon matSuffix>lock</mat-icon>
        </mat-form-field>
      </mat-card-content>

      <mat-card-actions align="end" style="float:right;clear:both">
        <button mat-flat-button 
                color="primary" 
                type="submit" 
                [disabled]="!loginForm.form.valid">
          Sign In
        </button>
      </mat-card-actions>
    </form>
  </mat-card>

  <mat-card *ngIf="lastError" class="error-card">
    <mat-icon color="warn">error</mat-icon>
    <div>
      <strong>Error {{lastError.status}}:</strong> {{lastError.message}}
    </div>
  </mat-card>
</div>